import { createFileRoute } from "@tanstack/react-router";
import SaintFloridaPage from "@/pages/learn/SaintFloridaPage";
export const Route = createFileRoute("/saint-tms-florida")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SAINT® TMS in Florida | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "SAINT® TMS is available in Florida at Neuro Wellness in Coral Springs. FDA-cleared 5-day fMRI-guided depression treatment. Free consultation and travel support.",
        },
        {
          property: "og:title",
          content: "SAINT® TMS in Florida | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "SAINT® TMS is available in Florida at Neuro Wellness in Coral Springs. FDA-cleared 5-day fMRI-guided depression treatment. Free consultation and travel support.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/saint-tms-florida",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/saint-tms-florida",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintFloridaPage />;
}
